module.exports = __webpack_public_path__ + "img/micon-6.0ce2e914.svg";